'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { cn } from '@/lib/cn';
import { motionPopLayout } from '@/styles/motionAnimations';
import { ShareIcon } from './ShareIcon';
export interface ShareProps {
  className?: string;
  iconClassName?: string;
}
export function Share(t0) {
  const $ = _c(14);
  const {
    className,
    iconClassName
  } = t0;
  const [shared, setShared] = useState(false);
  const [animToggle, setAnimToggle] = useState(false);
  const timeoutRef = useRef(undefined);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => () => {
      clearTimeout(timeoutRef.current);
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = async () => {
      ;
      try {
        await navigator.clipboard.writeText(window.location.toString());
        setAnimToggle(_temp);
        setShared(true);
        clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(() => {
          setShared(false);
        }, 4000);
      } catch (t4) {
        const error = t4;
        console.error(error);
      }
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const share = t3;
  const t4 = animToggle ? "true" : "false";
  let t5;
  if ($[3] !== className) {
    t5 = cn("cursor-pointer", className);
    $[3] = className;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const t6 = shared ? "URL copied!" : "Share";
  let t7;
  if ($[5] !== iconClassName) {
    t7 = cn("text-[20px]", iconClassName);
    $[5] = iconClassName;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== t7) {
    t8 = <ShareIcon className={t7} />;
    $[7] = t7;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== t4 || $[10] !== t5 || $[11] !== t6 || $[12] !== t8) {
    t9 = <AnimatePresence mode="popLayout" initial={false}><motion.button key={t4} className={t5} title={t6} data-testid="share-button" onClick={share} {...motionPopLayout}>{t8}</motion.button></AnimatePresence>;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  return t9;
}
function _temp(prev) {
  return !prev;
}